import { CrudService } from '@/services/crudService';

const RESOURCE_URL = `/publiccustomers`;
const crud = new CrudService();

export const accountService = {

  async getAccountDetails(id: string | number) {
    return crud.httpGet(`${RESOURCE_URL}/${id}`, null, undefined, 'json', {
      headers: {
        Accept: 'application/json',
      },
    });
  },

  async updateAccountDetails(accountData: Record<string, unknown>) {
    return crud.httpPut(`${RESOURCE_URL}/put-json`, accountData, undefined, 'json', {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
  }

};
